export const DEMO_INVOICE_VAT_RATES = [0.2, 0.1, 0.055, 0.021, 0]
